import Cookie from '../Core/Cookie';

function HideElements(elements) {
    elements.map((item) => {
        if (item !== null) {
            item.style.display = 'none';
        }
    });
}




export default class MobileVersion {
    constructor() {
        //Agregar aqui el elemento que se desea ocultar:
        this.elementos = [
            //Header
            document.querySelector('#header'),
            document.querySelector('#cabezal-banner'),
            
            //Footer
            document.querySelector('#pie'),

            //Aside (tercera)
            document.querySelector('#aside'),

            //LA NACION en BreadCumb
            document.querySelector('.breadcrumb > a:first-child'),
            document.querySelector('.breadcrumb > span:nth-child(2)'),

            //Section te Puede Interesar
            document.querySelector('#notas-sugeridas')
        ];

    }


    Load() {
        const isMobileApp = Cookie.read('platform');

        if (isMobileApp)
            HideElements(this.elementos);
    }


    isMobile() {
        return Cookie.read('platform');
    }

    SendEventMobile(event, data) {
        var request = {
            event: event,
            data: data
        };
        console.log('AppEvent: ', request);
        
        try {
            webkit && webkit.messageHandlers.ios.postMessage(JSON.stringify(request));
        } catch (err) {
            console.error('Error IOs: ' + err.message);
        }
        try {
            android && android.performClick(JSON.stringify(request));
        } catch (err) {
            console.error('Error Android: ' + err.message);
        }
    }
}


// WEBPACK FOOTER //
// ./Statics/scripts/Modules/MobileVersion.js